import React from 'react';
import '../CustomeSpinner/CustomeSpinner.css';
import centerImage from '../../assets/images/logo.png'; 

const CustomSpinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner-ring"></div>
      <img src={centerImage} alt="Center" className="spinner-center-image" />
    </div>
  );
};

export default CustomSpinner;
